import {
  evaluateCallsSessionDecision,
} from './CallsSessionDecisionEngine';

import {
  GOVERNOR_IDENTITY_REGISTRY,
  GOVERNOR_LIFECYCLE_IDENTIFIERS,
} from '../core';

export type CallsSessionExecution =
  | 'execute'
  | 'deny';

export interface CallsSessionExecutionResult {
  readonly governor: string;
  readonly governorId: string;
  readonly governorKey: string;
  readonly domain: string;
  readonly lifecycle: string;
  readonly evidenceSource: 'session-decision';
  readonly execution: CallsSessionExecution;
  readonly decision: 'allow' | 'block';
  readonly reasonCode: string;
  readonly reason: string;
  readonly evidenceCapturedAt: string;
}

export function executeCallsSession():
CallsSessionExecutionResult {

  const constitutional =
    GOVERNOR_IDENTITY_REGISTRY.CALLS;

  const decision =
    evaluateCallsSessionDecision();

  const execution =
    decision.decision === 'allow'
      ? 'execute'
      : 'deny';

  return Object.freeze({
    governor:
      constitutional.governor,

    governorId:
      constitutional.id,

    governorKey:
      constitutional.key,

    domain:
      constitutional.domain,

    lifecycle:
      GOVERNOR_LIFECYCLE_IDENTIFIERS.RUNTIME_ACTION,

    evidenceSource:
      'session-decision',

    execution,

    decision:
      decision.decision,

    reasonCode:
      decision.reasonCode,

    reason:
      decision.reason,

    evidenceCapturedAt:
      decision.evidenceCapturedAt,
  });
}
